module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vdige9-4224a11aba5b970b1ef8f05a713e87c4.jpg";